
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";

interface DoctorCardProps {
  name: string;
  role: string;
  image: string;
  description: string;
  socials?: {
    facebook?: string;
    twitter?: string;
    instagram?: string;
    linkedin?: string;
  };
}

export const DoctorCard = ({
  name,
  role,
  image,
  description,
  socials,
}: DoctorCardProps) => {
  return (
    <div className="overflow-hidden rounded-xl bg-white shadow-soft group hover-lift">
      <div className="aspect-[3/4] relative overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-serif font-medium mb-1">{name}</h3>
        <p className="text-dental-highlight text-sm mb-3">{role}</p>
        <p className="text-dental-muted text-sm mb-4">{description}</p>
      </div>
    </div>
  );
};
